import { NotFoundController } from './notFound.controller';
import template from './notFound.html';
// // import './notFound.scss';

export const notFoundComponent = {
  name: 'notFoundComponent',
  restrict: 'E',
  template,
  controller: NotFoundController,
  controllerAs: 'vm',
  bindings: {}
};
